<script setup lang="ts">
import { computed } from "vue";

interface Props {
  name: any;
  value: string | number | boolean;
  selected: any[];
  id: string;
  bgColor: string | any;
}

const props = defineProps<Props>();
const emit = defineEmits(["update:selected"]);

const checked = computed(() => props.selected.includes(props.value));

const updatedValue = () => {
  let newValue = [...props.selected];

  if (checked.value) {
    newValue.splice(newValue.indexOf(props.value), 1);
  } else {
    newValue.push(props.value);
  }

  emit("update:selected", newValue);
};
</script>

<template>
  <div class="flex items-start pb-2 pt-4 pr-2">
    <input
      class="w-6 h-6 text-primary-500 bg-white border-1 border-primary-900 rounded focus:ring-0"
      :style="`background-color: ${bgColor}`"
      type="checkbox"
      :id="`teal-checkbox${id}`"
      :name="name"
      :checked="checked"
      @input="updatedValue"
    />
    <label
      class="text-sm font-medium text-neautrals-900"
      :for="`teal-checkbox${id}`"
    >
      <span><slot></slot></span>
    </label>
  </div>
</template>
